module.exports = __webpack_public_path__ + "img/verdi_oak.37781856.jpg";